import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'

const app = createApp(App)

app.use(store)

// Sécurité anti-conflit sur $route
if (app.config.globalProperties.$route) {
  delete app.config.globalProperties.$route
}
if (app.config.globalProperties.$router) {
  delete app.config.globalProperties.$router
}

app.use(router)

app.mount('#app')
